import { AppButton, AppButtonProps } from 'components/atoms/CommonAppComponents';
import { StyledPlusIcon } from 'components/atoms/StyledIcons';

export type AddButtonProps = {
    addButtonLabel?: string;
    onAddButtonClick?: () => void;
    accessibilityLabel?: string;
} & AppButtonProps;

export const AddButton = ({
    addButtonLabel,
    onAddButtonClick,
    accessibilityLabel,
    ...appButtonProps
}: AddButtonProps) => (
    <AppButton
        icon={<StyledPlusIcon />}
        onClick={onAddButtonClick}
        type="primary"
        margin={0}
        accessibilityLabel={accessibilityLabel}
        {...appButtonProps}
    >
        {addButtonLabel}
    </AppButton>
);
